module.exports = __webpack_public_path__ + "media/images/marble-grey-1113c773326cd52d3901f2d480383852.png";